export class UserLogin {
    constructor(
    public UserName:string="",
    public Password:string="",
    )
    {

    }
}
